{
  "b2b-invoice-payment-statistics": {
    "src": "/images/research/invoice-payment-timing.webp",
    "srcset": "/images/research/invoice-payment-timing-640.webp 640w, /images/research/invoice-payment-timing-960.webp 960w, /images/research/invoice-payment-timing.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A paper invoice, clock and calendar connect to a payment tray, illustrating the time between billing and receiving payment."
  },
  "small-business-ai-adoption-statistics": {
    "src": "/images/research/business-ai-adoption.webp",
    "srcset": "/images/research/business-ai-adoption-640.webp 640w, /images/research/business-ai-adoption-960.webp 960w, /images/research/business-ai-adoption.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Office buildings surround a connected geometric AI prism, with a small workstation in front, illustrating varied business AI adoption."
  },
  "client-work-software-cost-index": {
    "src": "/images/research/software-subscription-costs.webp",
    "srcset": "/images/research/software-subscription-costs-640.webp 640w, /images/research/software-subscription-costs-960.webp 960w, /images/research/software-subscription-costs.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Contact, calendar, email and folder tiles linked by paper rings illustrate a team's collection of recurring software subscriptions."
  },
  "professional-services-labor-cost-statistics": {
    "src": "/images/research/labor-compensation-components.webp",
    "srcset": "/images/research/labor-compensation-components-640.webp 640w, /images/research/labor-compensation-components-960.webp 960w, /images/research/labor-compensation-components.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A planning sheet and pen sit beside an envelope holding a clock, coins and umbrella, illustrating the components of labor compensation."
  },
  "small-business-survival-rate-statistics": {
    "src": "/images/research/business-survival-pathways.webp",
    "srcset": "/images/research/business-survival-pathways-640.webp 640w, /images/research/business-survival-pathways-960.webp 960w, /images/research/business-survival-pathways.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Branching paper paths pass through seasonal arches toward business buildings and separate doors, illustrating business continuity and closure."
  },
  "small-business-cash-flow-statistics": {
    "src": "/images/research/small-business-cash-flow.webp",
    "srcset": "/images/research/small-business-cash-flow-640.webp 640w, /images/research/small-business-cash-flow-960.webp 960w, /images/research/small-business-cash-flow.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Invoices flow into a cash drawer while expense envelopes leave it, with a separate coin tray representing business reserves."
  },
  "payment-processing-cost-benchmarks": {
    "src": "/images/research/card-ach-payment-paths.webp",
    "srcset": "/images/research/card-ach-payment-paths-640.webp 640w, /images/research/card-ach-payment-paths-960.webp 960w, /images/research/card-ach-payment-paths.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Paper pathways from a bank card and bank building meet in a merchant's coin tray, illustrating card and bank payment processing."
  },
  "solo-business-revenue-benchmarks": {
    "src": "/images/research/solo-business-receipts.webp",
    "srcset": "/images/research/solo-business-receipts-640.webp 640w, /images/research/solo-business-receipts-960.webp 960w, /images/research/solo-business-receipts.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A single workspace with a laptop, notebook, camera and receipt envelopes illustrates income-generating work in a solo business."
  },
  "sole-proprietor-profit-margin-benchmarks": {
    "src": "/images/research/sole-proprietor-income-expenses.webp",
    "srcset": "/images/research/sole-proprietor-income-expenses-640.webp 640w, /images/research/sole-proprietor-income-expenses-960.webp 960w, /images/research/sole-proprietor-income-expenses.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A receipts folder and expense envelopes rest on a paper balance beside a coin tray, illustrating sole-proprietor income and expenses."
  },
  "employee-turnover-statistics-by-industry": {
    "src": "/images/research/employee-turnover-movements.webp",
    "srcset": "/images/research/employee-turnover-movements-640.webp 640w, /images/research/employee-turnover-movements-960.webp 960w, /images/research/employee-turnover-movements.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "People carrying work bags move along separate paths through office doorways, illustrating employee arrivals and departures."
  },
  "sales-productivity-crm-admin-statistics": {
    "src": "/images/research/sales-time-crm-administration.webp",
    "srcset": "/images/research/sales-time-crm-administration-640.webp 640w, /images/research/sales-time-crm-administration-960.webp 960w, /images/research/sales-time-crm-administration.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A client conversation and contact-card organizer flank a clock, illustrating the work time used for selling and CRM administration."
  },
  "crm-data-quality-ai-readiness-statistics": {
    "src": "/images/research/crm-data-quality-review.webp",
    "srcset": "/images/research/crm-data-quality-review-640.webp 640w, /images/research/crm-data-quality-review-960.webp 960w, /images/research/crm-data-quality-review.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Contact cards pass through an inspection gate toward an AI prism, while other cards remain in a separate review tray."
  },
  "ai-productivity-time-savings-benchmarks": {
    "src": "/images/research/ai-work-task-comparison.webp",
    "srcset": "/images/research/ai-work-task-comparison-640.webp 640w, /images/research/ai-work-task-comparison-960.webp 960w, /images/research/ai-work-task-comparison.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A researcher stands between matching task benches and clocks, with an AI prism nearby, illustrating comparison of work completion."
  },
  "ai-customer-service-performance-statistics": {
    "src": "/images/research/ai-assisted-customer-support.webp",
    "srcset": "/images/research/ai-assisted-customer-support-640.webp 640w, /images/research/ai-assisted-customer-support-960.webp 960w, /images/research/ai-assisted-customer-support.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A headset-wearing support specialist reviews a conversation ribbon beside an AI prism, with a feedback loop and case folder."
  },
  "workflow-automation-statistics-by-business-function": {
    "src": "/images/research/workflow-automation-departments.webp",
    "srcset": "/images/research/workflow-automation-departments-640.webp 640w, /images/research/workflow-automation-departments-960.webp 960w, /images/research/workflow-automation-departments.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Connected task tiles cross department desks and a human review gate, illustrating cross-functional workflow automation and oversight."
  },
  "cloud-software-adoption-statistics": {
    "src": "/images/research/cloud-software-businesses.webp",
    "srcset": "/images/research/cloud-software-businesses-640.webp 640w, /images/research/cloud-software-businesses-960.webp 960w, /images/research/cloud-software-businesses.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A layered paper cloud connects workstations in differently sized office buildings, with local folders beside the desks."
  },
  "crm-adoption-statistics": {
    "src": "/images/research/crm-business-contact-systems.webp",
    "srcset": "/images/research/crm-business-contact-systems-640.webp 640w, /images/research/crm-business-contact-systems-960.webp 960w, /images/research/crm-business-contact-systems.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Office buildings of different sizes connect to contact-card boxes, a filing cabinet and an address book, illustrating CRM organization."
  },
  "employee-absenteeism-statistics": {
    "src": "/images/research/employee-absence-work-schedule.webp",
    "srcset": "/images/research/employee-absence-work-schedule-640.webp 640w, /images/research/employee-absence-work-schedule-960.webp 960w, /images/research/employee-absence-work-schedule.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "An occupied workstation sits beside an empty chair, calendar and clock, illustrating absence from scheduled work without assigning a cause."
  },
  "paid-leave-employee-benefits-benchmarks": {
    "src": "/images/research/paid-leave-benefits-access.webp",
    "srcset": "/images/research/paid-leave-benefits-access-640.webp 640w, /images/research/paid-leave-benefits-access-960.webp 960w, /images/research/paid-leave-benefits-access.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A worker considers a benefits folder containing a calendar, umbrella, medical-care symbol and retirement coin nest."
  },
  "remote-hybrid-work-statistics": {
    "src": "/images/research/remote-hybrid-workplaces.webp",
    "srcset": "/images/research/remote-hybrid-workplaces-640.webp 640w, /images/research/remote-hybrid-workplaces-960.webp 960w, /images/research/remote-hybrid-workplaces.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A folded paper ribbon connects an individual home workspace with a shared office table, illustrating remote and hybrid work settings."
  },
  "freelancer-independent-contractor-statistics": {
    "src": "/images/research/independent-contractor-client-work.webp",
    "srcset": "/images/research/independent-contractor-client-work-640.webp 640w, /images/research/independent-contractor-client-work-960.webp 960w, /images/research/independent-contractor-client-work.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "An independent professional's project folders connect to separate client buildings, illustrating distinct client-work relationships."
  },
  "new-business-formation-statistics": {
    "src": "/images/research/business-applications-openings.webp",
    "srcset": "/images/research/business-applications-openings-640.webp 640w, /images/research/business-applications-openings-960.webp 960w, /images/research/business-applications-openings.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Application sheets pass through a processing arch beside a pending tray and a separate open business, distinguishing applications from openings."
  },
  "business-email-compromise-statistics": {
    "src": "/images/research/business-email-payment-security.webp",
    "srcset": "/images/research/business-email-payment-security-640.webp 640w, /images/research/business-email-payment-security-960.webp 960w, /images/research/business-email-payment-security.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A verification hand and shield separate a damaged email envelope from a payment tray, with a phone beside another envelope."
  },
  "project-management-success-failure-statistics": {
    "src": "/images/research/project-outcomes-review.webp",
    "srcset": "/images/research/project-outcomes-review-640.webp 640w, /images/research/project-outcomes-review-960.webp 960w, /images/research/project-outcomes-review.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "A milestone board connects to a delivery box and revision folder beside a stakeholder table, illustrating project outcomes and review."
  },
  "revenue-per-employee-benchmarks": {
    "src": "/images/research/revenue-employee-comparison.webp",
    "srcset": "/images/research/revenue-employee-comparison-640.webp 640w, /images/research/revenue-employee-comparison-960.webp 960w, /images/research/revenue-employee-comparison.webp 1440w",
    "width": 1440,
    "height": 611,
    "alt": "Employee silhouettes stand beside receipts and separate headcount cards joined by a measuring bridge, illustrating revenue-to-employment comparison."
  },
  "agency-pricing-benchmarks": {
    "src": "/images/research/agency-pricing-benchmarks-chart-1200.webp",
    "srcset": "/images/research/agency-pricing-benchmarks-chart-600.webp 600w, /images/research/agency-pricing-benchmarks-chart-900.webp 900w, /images/research/agency-pricing-benchmarks-chart-1200.webp 1200w",
    "width": 1200,
    "height": 446,
    "alt": "Bar chart of reported agency rate increases in separate survey years, with exact percentages and source context in the following table.",
    "caption": "Chart of cited source data; the accessible table below provides exact values, units and limitations."
  },
  "freelancer-rate-benchmarks": {
    "src": "/images/research/freelancer-rate-benchmarks-chart-1200.webp",
    "srcset": "/images/research/freelancer-rate-benchmarks-chart-600.webp 600w, /images/research/freelancer-rate-benchmarks-chart-900.webp 900w, /images/research/freelancer-rate-benchmarks-chart-1200.webp 1200w",
    "width": 1200,
    "height": 662,
    "alt": "Bar chart comparing selected UK freelancer day rates, with exact GBP amounts, disciplines and source context in the following table.",
    "caption": "Chart of cited source data; the accessible table below provides exact values, units and limitations."
  },
  "web-design-pricing-benchmarks": {
    "src": "/images/research/web-design-pricing-benchmarks-chart-1200.webp",
    "srcset": "/images/research/web-design-pricing-benchmarks-chart-600.webp 600w, /images/research/web-design-pricing-benchmarks-chart-900.webp 900w, /images/research/web-design-pricing-benchmarks-chart-1200.webp 1200w",
    "width": 1200,
    "height": 446,
    "alt": "Bar chart of the lower endpoints of three published web-design hourly bands; the table retains both endpoints and source limitations.",
    "caption": "Chart of cited source data; the accessible table below provides exact values, units and limitations."
  },
  "agency-profit-margin-benchmarks": {
    "src": "/images/research/agency-profit-margin-benchmarks-chart-1200.webp",
    "srcset": "/images/research/agency-profit-margin-benchmarks-chart-600.webp 600w, /images/research/agency-profit-margin-benchmarks-chart-900.webp 900w, /images/research/agency-profit-margin-benchmarks-chart-1200.webp 1200w",
    "width": 1200,
    "height": 518,
    "alt": "Bar chart of reported 2025 after-tax net margins by agency employee group; exact values and population limits follow in the table.",
    "caption": "Chart of cited source data; the accessible table below provides exact values, units and limitations."
  },
  "proposal-close-rate-benchmarks": {
    "src": "/images/research/proposal-close-rate-benchmarks-chart-1200.webp",
    "srcset": "/images/research/proposal-close-rate-benchmarks-chart-600.webp 600w, /images/research/proposal-close-rate-benchmarks-chart-900.webp 900w, /images/research/proposal-close-rate-benchmarks-chart-1200.webp 1200w",
    "width": 1200,
    "height": 518,
    "alt": "Bar chart of selected Proposify proposal close rates; the table identifies the overall sample separately from industry groups.",
    "caption": "Chart of cited source data; the accessible table below provides exact values, units and limitations."
  },
  "freelancer-late-payment-statistics": {
    "src": "/images/research/freelancer-late-payment-statistics-chart-1200.webp",
    "srcset": "/images/research/freelancer-late-payment-statistics-chart-600.webp 600w, /images/research/freelancer-late-payment-statistics-chart-900.webp 900w, /images/research/freelancer-late-payment-statistics-chart-1200.webp 1200w",
    "width": 1200,
    "height": 806,
    "alt": "Bar chart of how US freelancers facing missing payments got by in Freelancers Union’s 2015 survey, led by personal savings at 63% and credit cards at 44%.",
    "caption": "Chart of cited source data; the accessible table below provides exact values, units and limitations."
  },
  "freelance-writing-rates": {
    "src": "/images/research/freelance-writing-rates-chart-1200.webp",
    "srcset": "/images/research/freelance-writing-rates-chart-600.webp 600w, /images/research/freelance-writing-rates-chart-900.webp 900w, /images/research/freelance-writing-rates-chart-1200.webp 1200w",
    "width": 1200,
    "height": 662,
    "alt": "Bar chart of EFA 2026 upper per-word endpoints for work-for-hire writing: articles 45¢, blog posts 45¢, business and marketing 87.5¢, journalism 50¢, technical $1.00, medical $1.50.",
    "caption": "Chart of cited source data; the accessible table below provides exact values, units and limitations."
  },
  "client-work-software-price-tracker": {
    "src": "/images/research/client-work-software-price-tracker-chart-1200.webp",
    "srcset": "/images/research/client-work-software-price-tracker-chart-600.webp 600w, /images/research/client-work-software-price-tracker-chart-900.webp 900w, /images/research/client-work-software-price-tracker-chart-1200.webp 1200w",
    "width": 1200,
    "height": 806,
    "alt": "Bar chart of lowest paid plan prices on monthly billing as of October 20, 2026: 17hats $60, HoneyBook $36, Dubsado $35, FreshBooks $23, Bonsai $15 per user, Teamwork $13.99 per user, Moxie $12, Harvest $11 per seat.",
    "caption": "Chart of cited source data; the accessible table below provides exact values, units and limitations."
  }
}
